import { render, staticRenderFns } from "./syslog.vue?vue&type=template&id=3a1beef0&scoped=true&"
import script from "./syslog.vue?vue&type=script&lang=ts&"
export * from "./syslog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1beef0",
  null
  
)

export default component.exports